export default __webpack_public_path__ + "static/Vidrios_Aluminios_1-2fdf26727f4211bc625b0d80bf677df6.png";